import { render, staticRenderFns } from "./rts.vue?vue&type=template&id=2190a566&scoped=true"
import script from "./rts.vue?vue&type=script&lang=js"
export * from "./rts.vue?vue&type=script&lang=js"
import style0 from "./rts.vue?vue&type=style&index=0&id=2190a566&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2190a566",
  null
  
)

export default component.exports